enum Language {
  ENGLISH = 'en',
  GERMAN = 'de',
}

export { Language };
